<script setup>
import "@/styles/css/calculator-base.scss";
import "@/styles/css/seo-calculators.scss";
import { onMounted, ref } from "vue";
onMounted(() => {
  require("@/assets/js/swp.js");
});
const view = ref(false);
</script>
<template>
  <main class="upstox-calculators" id="swp-calculator">
    <!-- breadcrumb template -->
    <section class="breadcrumbs-sec">
      <div class="container breadcrumbs-ol">
        <div class="stocks-indices-breadcrumbs_wrap">
          <ol class="stocks-indices-breadcrumbs">
            <li>
              <a href="/">
                <span>Trading </span>
              </a>
            </li>
            <li>
              <a>
                <span>Calculators </span>
              </a>
            </li>
            <li>
              <span>SWP Calculator </span>
            </li>
          </ol>
        </div>
      </div>
    </section>
    <!-- end breadcrumb template -->

    <section class="calculator-background"></section>

    <section class="calculator">
      <div class="container">
        <h1 class="title">SWP Calculator</h1>
        <div class="cal-structure">
          <div class="inner-row cal-slider" id="cal-slider">
            <div class="input-section calc-slide">
              <div class="calc-slide-inner">
                <div class="form-group investment-main">
                  <label for="investment">
                    <h3 id="investment-title">Total Investment</h3>
                  </label>
                  <input
                    type="text"
                    id="investment"
                    value="₹ 100000"
                    class="input"
                    data-type="rupee"
                  />
                </div>

                <!-- input -->
                <div class="form-group">
                  <label>
                    <h3>Withdrawal Amount Per Month</h3>
                  </label>
                  <input
                    type="text"
                    id="withdrawal-per-month"
                    value="₹ 3000"
                    class="input"
                    data-type="rupee"
                  />
                </div>

                <div class="form-group group-merge-top">
                  <div class="group-merge-main">
                    <label for="investment">
                      <h3 id="investment-title">Expected Returns</h3>
                    </label>
                    <input
                      type="text"
                      value="2%"
                      step="0.1"
                      min="1"
                      max="40"
                      id="expected-returns-input"
                      class="input"
                      data-type="percent"
                    />
                  </div>
                  <input
                    type="range"
                    value="2"
                    step="0.1"
                    min="1"
                    max="40"
                    id="expected-returns-input-slider"
                    class="slider-range"
                  />
                </div>
                <div class="form-group">
                  <div class="group-merge-main">
                    <label for="investment">
                      <h3 id="investment-title">Tenure</h3>
                    </label>
                    <input
                      type="text"
                      name="tenure"
                      value="2 years"
                      step="1"
                      min="1"
                      max="30"
                      id="tenure-input"
                      class="input"
                      data-type="years"
                    />
                  </div>
                  <input
                    type="range"
                    value="2"
                    step="1"
                    min="1"
                    max="30"
                    id="tenure-input-slider"
                    class="slider-range"
                  />
                </div>

                <div class="mob-calc-btn">
                  <button id="calculate" class="calc-btn-mob">Calculate</button>
                </div>
              </div>
            </div>
            <div class="output-section calc-slide cal-loader">
              <div class="calc-slide-inner">
                <lottie-player
                  src="/json-data/lottie/calculator-loader.json"
                  background="transparent"
                  speed="1"
                  loop=""
                  autoplay=""
                ></lottie-player>
              </div>
            </div>
            <div class="output-section calc-slide">
              <div class="calc-slide-inner">
                <div class="mob-results">
                  <h5>
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/back-arrow.svg"
                      alt=""
                      id="back-button"
                    />
                    Your results
                  </h5>
                </div>
                <h3>Total value of your investment:</h3>
                <div class="distribution-bar background-color-bar">
                  <div class="grey investment" style="width: 5813.95%"></div>
                  <div class="green returns" style="width: 4186.05%"></div>
                </div>
                <div class="invest-list">
                  <ul>
                    <li>
                      <span class="grey-circle"></span>
                      <h5>Invested Amount</h5>
                    </li>
                    <li>
                      <span class="green-circle"></span>
                      <h5>Expected Returns</h5>
                    </li>
                  </ul>
                </div>

                <div class="row outer-listing-group">
                  <div class="outer-grp">
                    <h4>Invested Amount</h4>
                    <span id="invested-amount">₹ 1,00,000</span>
                  </div>
                  <div class="outer-grp">
                    <h4>Estimated Returns</h4>
                    <span id="est-amount">₹ 72,000</span>
                  </div>
                  <div class="outer-grp">
                    <h4>Total Value</h4>
                    <span id="total-investment">₹ 30,656</span>
                  </div>
                  <div class="bottom-text">
                    <p>
                      <span class="capital-text">ZERO</span> annual maintenance
                      charges only for new users for the
                      <strong>next 10 days</strong>
                    </p>
                    <a
                      href="https://wa.me/+917092362098"
                      class="get-start-btn"
                      >Get Started Today</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--------------last 3 calculations -------------------->

    <section class="last-three-calculations">
      <div class="container last-three-cal-mobile">
        <h3>Last 3 calculations</h3>
        <p>Your calculations are erased upon refreshing!</p>
        <div class="calc-inner" id="cal-history"></div>
      </div>
    </section>

    <!--------------------Start Key Indicies Template--------------------------->

    <section class="key-indices">
      <div class="container">
        <div class="key-indices-inner">
          <div class="key-indices-header">
            <h4>Key Indices in NSE</h4>
          </div>
          <div class="key-indices-content">
            <ul>
              <li>
                <a href="/indices/nifty-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 50"
                    />
                  </div>
                  <div class="key-content">NIFTY 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-next-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Next 50"
                    />
                  </div>
                  <div class="key-content">NIFTY NEXT 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-bank-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Bank"
                    />
                  </div>
                  <div class="key-content">NIFTY BANK</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-100-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 100"
                    />
                  </div>
                  <div class="key-content">NIFTY 100</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-200-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 200"
                    />
                  </div>
                  <div class="key-content">NIFTY 200</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-500-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 500"
                    />
                  </div>
                  <div class="key-content">NIFTY 500</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-midcap-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Midcap 50"
                    />
                  </div>
                  <div class="key-content">NIFTY MIDCAP 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-smlcap-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="NIFTY SMLCAP 50"
                    />
                  </div>
                  <div class="key-content">NIFTY SMLCAP 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/india-vix-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="India VIX"
                    />
                  </div>
                  <div class="key-content">INDIA VIX</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="key-indices">
      <div class="container">
        <div class="key-indices-inner">
          <div class="key-indices-header">
            <h4>Key Indices in BSE</h4>
          </div>
          <div class="key-indices-content">
            <ul>
              <li>
                <a href="/indices/sensex-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SENSEX"
                    />
                  </div>
                  <div class="key-content">SENSEX</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse100-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE100"
                    />
                  </div>
                  <div class="key-content">BSE100</div>
                </a>
              </li>
              <li>
                <a href="/indices/lrgcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="LRGCAP"
                    />
                  </div>
                  <div class="key-content">LRGCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/midcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="MIDCAP"
                    />
                  </div>
                  <div class="key-content">MIDCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/smlcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SMLCAP"
                    />
                  </div>
                  <div class="key-content">SMLCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse500-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE500"
                    />
                  </div>
                  <div class="key-content">BSE500</div>
                </a>
              </li>
              <li>
                <a href="/indices/allcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="ALLCAP"
                    />
                  </div>
                  <div class="key-content">ALLCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse200-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE200"
                    />
                  </div>
                  <div class="key-content">BSE200</div>
                </a>
              </li>
              <li>
                <a href="/indices/bseipo-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSEIPO"
                    />
                  </div>
                  <div class="key-content">BSEIPO</div>
                </a>
              </li>
              <li>
                <a href="/indices/smeipo-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SMEIPO"
                    />
                  </div>
                  <div class="key-content">SMEIPO</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!--------------------END Key Indicies Template--------------------------->

    <!-- Calculator Qna Section -->

    <section class="container calculator-info">
      <h2>What is SWP?</h2>
      <p></p>
      <p>
        A systematic withdrawal plan (SWP) provides regular income to investors.
        You can withdraw a fixed or a variable amount on a predetermined date
        every month, quarter, or year. Cash flows can be customised to withdraw
        either a fixed amount or the investment’s capital gains. Let’s say you
        own 10,000 units in a mutual fund scheme. You have specified a set of
        instructions to the mutual fund house whereby you seek to withdraw
        ₹4,000 every month through the SWP. On 1 January 2020, the NAV of the
        scheme was ₹10. The mutual fund house would redeem 400 units (₹4,000/10
        = 400 units) and give you an amount of ₹4,000. You still have 9,600
        units left in the mutual fund scheme. If on 1 February 2020, the NAV of
        the mutual fund scheme increased to ₹15, the mutual fund house would
        redeem 266 units (₹4,000/ ₹15 = 266 units) and give you ₹4,000 for the
        month of February. Now you are left with 9,600 units – 266 units or
        9,334 units. You can repeat the computations for the next several months
        in the same way.
      </p>
      <p></p>
    </section>
    <!-- Calculator Faqs Section-->

    <section class="faqs">
      <div class="container">
        <div class="faq-card nav-list" id="faq">
          <div class="faq-card-details stock-card-header">
            <div class="faq-card-desc">
              <h2 class="heading">Frequently Asked Questions</h2>
            </div>
          </div>
          <div class="stock-card-content dynamic-faq">
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-1">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    href="#collapse-1"
                  >
                    <span class="flex-grow">What is the SWP calculator?</span>
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="What is the SWP calculator?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-1" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    Using the Upstox SWP calculator, you can see the withdrawals
                    from your mutual funds on a monthly basis. It displays the
                    total value of your mutual fund investment after
                    withdrawals. Through the systematic withdrawal plan, you
                    will be able to receive a regular income. The SWP calculator
                    has a formula box where you can enter the total investment
                    amount, withdrawal per month, annual rate of return, and
                    tenure. You can use the SWP calculator to determine the
                    future value of your mutual fund investments.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-2">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    href="#collapse-2"
                  >
                    <span class="flex-grow">How does an SWP work?</span>
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="How does an SWP work?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-2" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    SWPs and SIPs work in opposite ways. SIPs allow investors to
                    invest a set amount at predetermined intervals, whereas SWPs
                    allow investors to withdraw a set amount at predetermined
                    intervals. Depending on the investor’s needs, they can pick
                    the amount, the frequency and the duration of the SWP.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-3">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    href="#collapse-3"
                  >
                    <span class="flex-grow">When can one use an SWP?</span>
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="When can one use an SWP?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-3" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    When an investor needs a consistent cash flow from his/her
                    investments, he/she might opt for an SWP. Every person’s
                    need for a SWP is different. SWP can be used for a variety
                    of purposes, including children’s education, EMI repayment,
                    and retirement.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-4">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    href="#collapse-4"
                  >
                    <span class="flex-grow"
                      >How does long-term and short-term capital gain affect my
                      tax implications?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="How does long-term and short-term capital gain affect my tax implications?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-4" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    For equity-oriented scheme: If your holding period is less
                    than 1 year, the gains will be calculated as short-term
                    capital gains and will be taxed at 15% and if the holding
                    period is more than 1 year, then long-term capital gains tax
                    of 10% will be levied if the total capital gains exceed
                    ₹1,00,000 in a year.
                  </p>
                  <p class="visible">
                    For debt-oriented scheme: If your holding period is less
                    than 3 years, gains will be calculated as short-term capital
                    gains and will be taxed as per the investors’ tax slab and
                    if the holding period is more than 3 years, then long-term
                    capital gains tax of 20% will be levied with the benefit of
                    indexation.
                  </p>
                  <p class="visible">
                    Note: In view of the individual nature of the implications,
                    each investor is advised to consult his or her own tax
                    advisors/authorised dealers with respect to the specific
                    amount of tax and other implications arising out of his or
                    her participation in the schemes.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-5">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    href="#collapse-5"
                  >
                    <span class="flex-grow"
                      >When should an investor opt for an SWP scheme?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="When should an investor opt for an SWP scheme?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-5" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    SWP is an ideal solution during retirement. Most people
                    prefer conventional sources for investment to invest the
                    lump-sum amount received during retirement. These
                    traditional sources are taxable. SWP offers a tax-efficient
                    way to earn a regular income. Therefore, retirees can earn a
                    regular income and benefit from capital appreciation. SWP is
                    not just for the retirees; it is also for people with
                    multiple dependents. Employees with family responsibilities
                    who require additional income can also opt for the SWP
                    option. Children’s educational needs, travel needs, and
                    financial goals approaching the deadline are a few reasons
                    why individuals choose a SWP option.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-6">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    href="#collapse-6"
                  >
                    <span class="flex-grow"
                      >What are the withdrawal options under an SWP
                      scheme?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="What are the withdrawal options under an SWP scheme?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-6" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    The withdrawal options under the SWP Scheme are determined
                    by the frequency of withdrawals. An investor can withdraw
                    their funds on a monthly, quarterly, semi-annual, or annual
                    basis. Withdrawals can be made from either the capital or
                    the appreciated portion of the account. Withdrawals may have
                    a negative impact on the investment’s value. In this case,
                    the SWP calculator can assist in determining the final
                    amount. Hence, it’s a good idea to think about your goals
                    and needs before choosing a plan.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-7">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    href="#collapse-7"
                  >
                    <span class="flex-grow">What are the benefits of SWP?</span>
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="What are the benefits of SWP?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-7" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    For retirees, it is a source of regular fixed income and for
                    employees, it is a source of additional income. If carefully
                    planned, an SWP can be a source of steady income to meet
                    financial goals. An SWP allows a tax benefit on long-term
                    capital gains up to ₹100,000, but gains above ₹100,000 are
                    taxable.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-8">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    href="#collapse-8"
                  >
                    <span class="flex-grow">Is SWP a good option?</span>
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="Is SWP a good option?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-8" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    The SWP is a better choice in volatile markets. Investors
                    can keep their money in the mutual fund while making partial
                    withdrawals. As a result, investors can expect a consistent
                    return on their investments. Investors can use the SWP
                    option to generate a secondary income in addition to their
                    fixed income.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-9">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    href="#collapse-9"
                  >
                    <span class="flex-grow"
                      >Which is better, profit from SWP or dividend?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="Which is better, profit from SWP or dividend?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-9" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    SWP is better than dividend plans. This is because dividends
                    are taxable in the hands of investors according to their
                    income-tax slab rate. Also, dividends above ₹5,000 are
                    subject to TDS of 10%. In SWP plans, investors are liable to
                    pay tax only for gains above ₹100,000.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Similar Calculator Section-->
    <!-- text start similar-->
    <section class="similar_section">
      <div class="container">
        <div class="heading-wrap">
          <h2 class="fs-28 bold help_here">Similar Calculator</h2>
          <button
            class="similar-btn btn-all"
            v-if="!view"
            @click="view = !view"
          >
            View all
          </button>
          <button
            class="similar-btn btn-less"
            v-if="view"
            @click="view = !view"
          >
            View less
          </button>
        </div>
        <div class="smooth-wrap" :class="view ? 'smooth-wrap2' : ''">
          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Brokerage Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Margin Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Mutual Fund Returns Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SIP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPV Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Future Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> ELSS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Option Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> PPF Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Annual Growth Rate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> National Savings Certificate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Sukanya Samriddhi Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Atal Pension Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Gratuity calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Simple Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Fixed Deposit Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> GST Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> HRA Calculator</a>
            </h3>
          </div>
        </div>
      </div>
    </section>
    <!-- Calculator Disclaimer Section -->
    <section class="container calculator-disclaimer">
      <p></p>
      <p>
        Disclaimer:<br />
        This calculator is meant to be used for indicative purposes only. It is
        designed to assist you in determining the appropriate amount of
        prospective investments. This calculator alone is not sufficient and
        shouldn’t be used for the development or implementation of any
        investment strategy. Upstox does not take the responsibility/liability
        nor does it undertake the authenticity of the figures calculated
        therein. Upstox makes no warranty about the accuracy of the
        calculators/reckoners. The examples do not claim to represent the
        performance of any security or investments. In view of the individual
        nature of tax consequences, each investor is advised to consult his/her
        own professional tax advisor before making any investment decisions on
        the basis of the results provided through the use of this calculator.
      </p>
      <p></p>
    </section>
  </main>
</template>
<style scoped>
</style>
